import React from "react"
import Image from "./image"

const SepiaImage = ({ filename, alt }) => <Image filename={filename} alt={alt} className="image-filter sepia-filter"/>


export default SepiaImage
